
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import DocumentListItem from "./DocumentListItem";

interface UploadedDocumentsCardProps {
  documents: Array<any>;
}

const UploadedDocumentsCard = ({ documents }: UploadedDocumentsCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Uploaded Documents</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-4">
          {documents.map((document, index) => (
            <DocumentListItem key={index} document={document} index={index} />
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default UploadedDocumentsCard;
